import { s as sessionsStore } from "./session.js";
import { redirect } from "@sveltejs/kit";
const handle = async ({ event, resolve }) => {
  const sessionId = event.cookies.get("session");
  if (!sessionId) {
    if (event.url.pathname.startsWith("/mgr") && !event.url.pathname.startsWith("/mgr/login")) {
      throw redirect(302, "/mgr/login");
    }
    return resolve(event);
  }
  const sessionUser = sessionsStore.get(sessionId);
  if (!sessionUser) {
    return resolve(event);
  }
  event.locals.user = sessionUser;
  return resolve(event);
};
export {
  handle
};
